import { PlayIcon } from "@heroicons/react/24/solid";

const videos = [
  {
    name: "Nextloop Spotlight",
    role: "Food Stall Owner Series",
    status: "Filming in Progress",
    img: "https://images.unsplash.com/photo-1551218808-94e220e084d2",
  },
  {
    name: "Nextloop Spotlight",
    role: "Entrepreneur Journey",
    status: "Coming Soon",
    img: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",
  },
  {
    name: "Nextloop Spotlight",
    role: "Behind the Business",
    status: "Launching Soon",
    img: "https://images.unsplash.com/photo-1504674900247-0877df9cc836",
  },
];

export default function SecondSectionSpotlight() {
  return (
    <section className="">
      <div className="max-w-7xl mx-auto px-6 text-center">
        {/* SECTION HEADER */}
        <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
          NextLoop <span className="text-[#92abc4]">Spotlight</span>
        </h2>
        <p className="text-gray-500 mt-3 max-w-2xl mx-auto leading-relaxed">
          From spotlight to handshakes, we create stories that transform visibility into meaningful connections. Through engaging content, interviews, and behind-the-scenes insights, our digital platform shines a light on people, ideas, and moments that matter. We don’t just showcase; we connect, inspire, and build relationships that last beyond the screen.
        </p>

        {/* CARDS */}
        <div className="grid md:grid-cols-3 gap-8 mt-14">
          {videos.map((v, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl shadow-sm p-5 text-left hover:shadow-md transition"
            >
              {/* HEADER */}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-slate-900 text-white flex items-center justify-center font-bold">
                  NL
                </div>
                <div>
                  <p className="font-semibold">{v.name}</p>
                  <p className="text-xs text-slate-500">{v.role}</p>
                </div>
              </div>

              {/* IMAGE */}
              <div className="relative rounded-xl overflow-hidden">
                <img
                  src={v.img}
                  alt={v.role}
                  className="w-full h-44 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                  <PlayIcon className="w-12 h-12 text-white opacity-80" />
                </div>
              </div>

              {/* STATUS */}
              <div className="mt-4">
                <span
                  className="inline-block text-xs font-semibold uppercase tracking-wide
                             bg-blue-100 text-blue-700 px-3 py-1 rounded-full"
                >
                  {v.status}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* FOOTER TEXT */}
        <p className="mt-12 text-slate-500">
          First episodes dropping soon on YouTube.
        </p>
      </div>
    </section>
  );
}
